// src/stores/authStore.js
import { reactive } from "vue";
import axios from "axios";

const BACKEND_URL =
  process.env.VUE_APP_BACKEND_URL || "http://localhost:8081";

export const authStore = reactive({
  usuario: null,
  // Queda en true después de la primera consulta a /auth/me,
  // para no repetirla en cada cambio de ruta.
  verificado: false,

  get autenticado() {
    return this.usuario !== null;
  },

  get nombreVisible() {
    if (!this.usuario) return "";
    return this.usuario.nombre || this.usuario.username;
  },

  /**
   * Consulta la sesión al backend una sola vez y guarda el
   * resultado. Las llamadas siguientes reutilizan lo guardado
   * salvo que se pida forzar la consulta.
   */
  async cargarSesion(forzar = false) {
    if (this.verificado && !forzar) {
      return this.usuario;
    }

    try {
      const r = await axios.get(`${BACKEND_URL}/auth/me`);
      this.usuario = r.data?.usuario || null;
    } catch (e) {
      // Un 401 aquí es lo normal cuando no hay sesión iniciada.
      this.usuario = null;
    }

    this.verificado = true;
    return this.usuario;
  },

  definirUsuario(usuario) {
    this.usuario = usuario || null;
    this.verificado = true;
  },

  limpiar() {
    this.usuario = null;
    this.verificado = true;
  },
});

export default authStore;
